import $ from 'jquery';
import { getScrollBarWidth, getWindowWidth } from './functions';

const $window = $(window);
const $page = $('.page');

bindInject();

function bindInject() {
    injectProps();
    $window.on('resize:width', injectProps);
}

function injectProps() {
    injectWindowProps();
    injectScrollBarProps();
}

function injectWindowProps() {
    $page.css('--window-width', getWindowWidth() + 'px');
}

function injectScrollBarProps() {
    $page.css('--scrollbar-width', getScrollBarWidth() + 'px');
}
